import { render, staticRenderFns } from "./CargaPorDocente.vue?vue&type=template&id=c0ae8e00&"
import script from "./CargaPorDocente.vue?vue&type=script&lang=js&"
export * from "./CargaPorDocente.vue?vue&type=script&lang=js&"
import style0 from "./CargaPorDocente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports